import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'
import TableLoading from 'shared/tables/table-loading'
import TableFooter from 'shared/tables/table-footer'
import MutedText from 'shared/forms/muted-text'
import UserBadges from 'duties/employees/UserBadges'
import { useRoleEmployees } from 'api/hooks/use-role-employees'
import InactiveUsersToggle from 'duties/filters/inactive-users'

// Filter state lives in show.jsx so the Actions dropdown export stays in
// sync with what this tab displays.
function EmployeesTab({ params, setParams }) {
  const { data, isSuccess, isLoading } = useRoleEmployees({
    params: params
  })

  return (
    <Row>
      <Col sm={12}>
        <Card className="border">
          <Card.Header className="bg-white">
            <Row>
              <Col sm="auto">
                <span className="text-muted">Users</span>
              </Col>
              <Col sm="auto">
                <InactiveUsersToggle params={params} setParams={setParams} />
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            {/* TODO: Consolidate to a single Users (Employees) Table */}
            <Table responsive size="sm">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Department</th>
                  <th>Location</th>
                  <th>Job Class</th>
                </tr>
              </thead>

              <tbody>
                {isLoading && <TableLoading columns={1} />}
                {isSuccess &&
                  data.data.map((a) => (
                    <tr key={`role-row-${a.id}`}>
                      <td>
                        <a
                          href={`/users/${a.id}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {a.external_id}{' '}
                        </a>
                        <UserBadges user={a} />
                      </td>
                      <td>
                        <MutedText className="ms-2">
                          {a.department_name}
                        </MutedText>
                      </td>
                      <td>
                        <MutedText className="ms-2">
                          {a.location}
                        </MutedText>
                      </td>
                      <td>
                        <MutedText className="ms-2">
                          {a.job_class}
                        </MutedText>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
            {isSuccess && (
              <TableFooter
                params={params}
                setParams={setParams}
                meta={data.meta}
              />
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default EmployeesTab
